import type { ReactElement } from 'react'
import { Typography } from '@mui/material'
import { styles } from './constants'

const IntroText = ({ lastUpdated }: { lastUpdated: string }): ReactElement => {
  return (
    <Typography variant="body2" sx={styles.introText}>
      This app stores only the data needed for core functionality in your browser. Optional Beamer and Analytics
      cookies are listed below and are off unless you enable them.
    </Typography>
  )
}

export default IntroText
